"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeFilter = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = require("date-fns");
var fieldsProps_1 = require("../utils/fieldsProps");
var icons_1 = require("@material-ui/icons");
var react_intl_1 = require("react-intl");
function DateRangeFilter(props) {
    var _a, _b;
    var column = props.column;
    var filterValue = column.filterValue, setFilter = column.setFilter, columnType = column.columnType, filterField = column.filterField;
    var filterType = 'date';
    var handleFromChange = react_1.useCallback(function (newFrom) {
        var value = __assign(__assign({}, filterValue === null || filterValue === void 0 ? void 0 : filterValue.value), { from: newFrom ? date_fns_1.formatISO(date_fns_1.startOfDay(newFrom)) : undefined });
        var newValue = filterField
            ? { filterType: filterType, columnType: columnType, filterField: filterField, value: value }
            : { filterType: filterType, columnType: columnType, value: value };
        setFilter(value.to || value.from ? newValue : undefined);
    }, [filterValue, setFilter]);
    var handleToChange = react_1.useCallback(function (newTo) {
        var value = __assign(__assign({}, filterValue === null || filterValue === void 0 ? void 0 : filterValue.value), { to: newTo ? date_fns_1.formatISO(date_fns_1.endOfDay(newTo)) : undefined });
        var newValue = filterField
            ? { filterType: filterType, columnType: columnType, filterField: filterField, value: value }
            : { filterType: filterType, columnType: columnType, value: value };
        setFilter(value.to || value.from ? newValue : undefined);
    }, [filterValue, setFilter]);
    var fromStr = (_a = filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) === null || _a === void 0 ? void 0 : _a.from;
    var toStr = (_b = filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) === null || _b === void 0 ? void 0 : _b.to;
    var from = react_1.useMemo(function () { return (fromStr ? date_fns_1.parseISO(fromStr) : null); }, [fromStr]);
    var to = react_1.useMemo(function () { return (toStr ? date_fns_1.parseISO(toStr) : null); }, [toStr]);
    var handleFromClear = react_1.useCallback(function (e) {
        e.stopPropagation();
        handleFromChange(null);
    }, [handleFromChange]);
    var handleToClear = react_1.useCallback(function (e) {
        e.stopPropagation();
        handleToChange(null);
    }, [handleToChange]);
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 1, justify: "space-between" },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
            react_1.default.createElement(pickers_1.DatePicker, __assign({}, fieldsProps_1.pickerProps, { label: column.shortHeader, placeholder: intl.formatMessage({ id: 'ttable.from', defaultMessage: 'C' }), value: from, onChange: handleFromChange }, (to && { maxDate: to }), { InputProps: {
                    endAdornment: (react_1.default.createElement(core_1.IconButton, { onClick: handleFromClear },
                        react_1.default.createElement(icons_1.Clear, null))),
                } }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
            react_1.default.createElement(pickers_1.DatePicker, __assign({}, fieldsProps_1.pickerProps, { label: "", placeholder: intl.formatMessage({ id: 'ttable.to', defaultMessage: 'по' }), value: to, onChange: handleToChange }, (from && { minDate: from }), { InputProps: {
                    endAdornment: (react_1.default.createElement(core_1.IconButton, { onClick: handleToClear },
                        react_1.default.createElement(icons_1.Clear, null))),
                } })))));
}
exports.DateRangeFilter = DateRangeFilter;
